(function () {
  'use strict';
  var CS = window.CheekySanta || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || CS.moneyFormat || '£{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    var key = m ? m[1] : 'amount', value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- Header ---------- */
  var menuBtn = $('#menuBtn');
  if (menuBtn) menuBtn.addEventListener('click', function () { $('#mobileNav').classList.toggle('open'); });
  var searchBtn = $('#searchBtn');
  if (searchBtn) searchBtn.addEventListener('click', function () {
    var s = $('#searchBar'); s.classList.toggle('open');
    if (s.classList.contains('open')) $('input[type=search]', s).focus();
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim');
  function openCart() { if (!drawer) return; drawer.classList.add('show'); scrim.classList.add('show'); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('show'); scrim.classList.remove('show'); }
  window.CheekySanta.openCart = openCart;

  function renderCart(cart) {
    if (!drawer) return;
    var badge = $('#cartCount');
    if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
    var items = $('#drItems'), foot = $('#drFoot');
    if (!cart.items.length) {
      items.innerHTML = '<div class="dr-empty">Your cart is empty<br><button type="button" class="btn-outline" data-close-cart>Continue shopping</button></div>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = '';
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : CS.cartImageFallback;
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' / ');
      var discounts = (it.line_level_discount_allocations || []).map(function (d) {
        return '<span class="disc">' + esc(d.discount_application.title) + ' (-' + formatMoney(d.amount) + ')</span>';
      }).join('');
      var orig = it.original_line_price !== it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
      return '<div class="line">' +
        '<a href="' + esc(it.url) + '"><img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy"></a>' +
        '<div class="ln"><b>' + esc(it.product_title) + '</b>' + (opts ? '<small>' + opts + '</small>' : '') + discounts +
        '<div class="qty"><button type="button" data-key="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-key="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="lp">' + orig + formatMoney(it.final_line_price) +
        '<button type="button" class="rm" data-key="' + esc(it.key) + '" data-q="0">Remove</button></div></div>';
    }).join('');
    var disc = $('#drDisc');
    var cartDiscounts = (cart.cart_level_discount_applications || []);
    var totalDisc = cart.total_discount || 0;
    if (disc) {
      if (totalDisc > 0) {
        var names = cartDiscounts.map(function (d) { return d.title; }).join(', ');
        disc.innerHTML = '<span>' + esc(names || 'Discount') + '</span><span>-' + formatMoney(totalDisc) + '</span>';
        disc.hidden = false;
      } else { disc.hidden = true; }
    }
    $('#subtotal').textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(CS.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function changeLine(key, qty) {
    drawer.classList.add('loading');
    return fetch(CS.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); })
      .finally(function () { drawer.classList.remove('loading'); });
  }

  if (drawer) {
    var cartBtn = $('#cartBtn');
    if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); fetchCart(); openCart(); });
    $('#closeCart').addEventListener('click', closeCart);
    scrim.addEventListener('click', closeCart);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
      var b = e.target.closest('button[data-key]');
      if (b) changeLine(b.getAttribute('data-key'), parseInt(b.getAttribute('data-q'), 10));
    });
  }

  /* ---------- Product section ---------- */
  var section = $('[data-product-section]');
  if (section) initProduct(section);

  function initProduct(sec) {
    var product = JSON.parse($('[data-product-json]', sec).textContent);
    var variants = {};
    product.variants.forEach(function (v) { variants[v.id] = v; });
    var disc = parseFloat(sec.getAttribute('data-bundle-discount') || '0');
    var form = $('#product-form');
    var idInput = $('#variantId');
    var qty = 1;
    var picks = { 1: [], 2: [] };

    // initial picks from rendered "on" buttons
    $$('.bundle', sec).forEach(function (b) {
      var q = +b.getAttribute('data-qty');
      $$('.sizes', b).forEach(function (row) {
        var on = $('.size.on', row) || $('.size:not([disabled])', row);
        if (on) { $$('.size', row).forEach(function (x) { x.classList.toggle('on', x === on); }); }
        picks[q][+row.getAttribute('data-item')] = on ? +on.getAttribute('data-variant') : null;
      });
    });
    if (!picks[1].length && idInput) picks[1] = [+idInput.value];
    if (!picks[2].length && idInput) picks[2] = [+idInput.value, +idInput.value];

    function currentVariants() { return picks[qty].slice(0, qty).map(function (id) { return variants[id]; }).filter(Boolean); }

    function updatePrices() {
      var v1 = variants[picks[1][0]] || product.variants[0];
      var b2 = (picks[2].length ? picks[2] : [v1.id, v1.id]).map(function (id) { return variants[id] || v1; });
      var b2price = Math.round((b2[0].price + b2[1].price) * (100 - disc) / 100);
      var b2compare = (b2[0].compare_at_price || b2[0].price) + (b2[1].compare_at_price || b2[1].price);
      var set = function (sel, txt) { var el = $(sel, sec); if (el) el.textContent = txt; };
      set('[data-b1-price]', formatMoney(v1.price));
      var b1c = $('[data-b1-compare]', sec);
      if (b1c) { b1c.hidden = !(v1.compare_at_price > v1.price); b1c.textContent = formatMoney(v1.compare_at_price || 0); }
      set('[data-b2-price]', formatMoney(b2price));
      set('[data-b2-compare]', formatMoney(b2compare));

      var shownPrice = qty === 2 ? b2price : v1.price;
      var shownCompare = qty === 2 ? b2compare : (v1.compare_at_price || 0);
      $('#mainPrice').textContent = formatMoney(shownPrice);
      var st = $('#stPrice'); if (st) st.textContent = formatMoney(shownPrice);
      var mc = $('#mainCompare'), ms = $('#mainSave');
      if (shownCompare > shownPrice) {
        var pct = Math.round((shownCompare - shownPrice) * 100 / shownCompare);
        mc.textContent = formatMoney(shownCompare); mc.hidden = false;
        if (ms) { ms.textContent = 'SAVE ' + pct + '%'; ms.hidden = false; }
      } else { mc.hidden = true; if (ms) ms.hidden = true; }

      var all = currentVariants();
      var available = all.length && all.every(function (v) { return v.available; });
      [$('#atc'), $('#atc2')].forEach(function (b) { if (b) b.disabled = !available; });
      var sl = $('#stockLine'); if (sl) sl.hidden = !available;
      if (idInput && v1) idInput.value = v1.id;
    }

    function selectBundle(q) {
      qty = q;
      $$('.bundle', sec).forEach(function (b) {
        var on = +b.getAttribute('data-qty') === q;
        b.classList.toggle('on', on); b.setAttribute('aria-checked', on);
      });
      updatePrices();
    }

    function showVariantImage(v) {
      if (v && v.featured_media && v.featured_media.preview_image) {
        var idx = mediaIndex(v.featured_media.preview_image.src);
        if (idx > -1) show(idx);
      }
    }

    $$('.bundle', sec).forEach(function (b) {
      var q = +b.getAttribute('data-qty');
      b.addEventListener('click', function (e) {
        var sb = e.target.closest('.size');
        if (sb) {
          e.stopPropagation();
          if (sb.disabled) return;
          var row = sb.parentElement;
          $$('.size', row).forEach(function (x) { x.classList.toggle('on', x === sb); });
          picks[q][+row.getAttribute('data-item')] = +sb.getAttribute('data-variant');
          if (q !== qty) selectBundle(q); else updatePrices();
          showVariantImage(variants[+sb.getAttribute('data-variant')]);
          return;
        }
        if (e.target.closest('.open-size')) { e.stopPropagation(); openSize(); return; }
        if (q !== qty) selectBundle(q);
      });
      b.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === b) { e.preventDefault(); selectBundle(q); }
      });
    });

    /* Add to cart */
    function addToCart(e) {
      if (e) e.preventDefault();
      var err = $('#formError'); err.textContent = '';
      var counts = {};
      currentVariants().forEach(function (v) { counts[v.id] = (counts[v.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
      if (!items.length) { err.textContent = 'Please choose a size.'; return; }
      var btns = [$('#atc'), $('#atc2')];
      btns.forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); } });
      fetch(CS.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        return fetchCart();
      }).then(function () {
        openCart();
      }).catch(function (j) {
        err.textContent = (j && (j.description || j.message)) || 'Could not add to cart. Please try again.';
      }).finally(function () {
        btns.forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
        updatePrices();
      });
    }
    if (form) form.addEventListener('submit', addToCart);
    var atc2 = $('#atc2'); if (atc2) atc2.addEventListener('click', addToCart);

    /* Gallery + lightbox */
    var thumbs = $$('#thumbs button', sec);
    var imgs = thumbs.map(function (t) { return { src: t.getAttribute('data-src'), alt: t.getAttribute('data-alt') }; });
    var cur = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('on'); }));
    function mediaIndex(src) {
      var base = function (u) { return (u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*(?=\.)/, ''); };
      for (var i = 0; i < imgs.length; i++) if (base(imgs[i].src) === base(src)) return i;
      return -1;
    }
    function show(i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      var p = $('#mainPhoto'); p.style.opacity = 0;
      setTimeout(function () { p.src = imgs[cur].src; p.alt = imgs[cur].alt; p.style.opacity = 1; }, 120);
      thumbs.forEach(function (b, j) { b.classList.toggle('on', j === cur); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var lb = $('#lightbox');
    function openLb(i) { if (!imgs.length) return; cur = (i + imgs.length) % imgs.length; $('#lbImg').src = imgs[cur].src; $('#lbImg').alt = imgs[cur].alt; lb.classList.add('show'); }
    function closeLb() { lb.classList.remove('show'); show(cur); }
    $('#mainImg').addEventListener('click', function () { openLb(cur); });
    $('#lbClose').addEventListener('click', closeLb);
    $('#lbPrev').addEventListener('click', function (e) { e.stopPropagation(); openLb(cur - 1); });
    $('#lbNext').addEventListener('click', function (e) { e.stopPropagation(); openLb(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });

    /* Size modal */
    var sm = $('#sizeModal');
    function openSize() { sm.classList.add('show'); }
    $$('.open-size').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); openSize(); }); });
    $('#closeSize').addEventListener('click', function () { sm.classList.remove('show'); });
    sm.addEventListener('click', function (e) { if (e.target === sm) sm.classList.remove('show'); });

    /* Delivery dates */
    var tr = $('#track', sec);
    if (tr) {
      var r = tr.getAttribute('data-ready').split(',').map(Number);
      var d = tr.getAttribute('data-deliver').split(',').map(Number);
      var addBiz = function (date, n) { date = new Date(date); while (n > 0) { date.setDate(date.getDate() + 1); var w = date.getDay(); if (w !== 0 && w !== 6) n--; } return date; };
      var f = function (x) { return x.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }); };
      var range = function (a, b) { return a === b ? f(addBiz(now, a)) : f(addBiz(now, a)) + ' - ' + f(addBiz(now, b)); };
      var now = new Date();
      $('[data-d1]', tr).textContent = f(now);
      $('[data-d2]', tr).textContent = range(r[0], r[1]);
      $('[data-d3]', tr).textContent = range(d[0], d[1]);
    }

    /* Sticky ATC */
    var sticky = $('#sticky');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe($('#atc'));
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeCart(); lb.classList.remove('show'); sm.classList.remove('show'); }
      if (lb.classList.contains('show')) {
        if (e.key === 'ArrowLeft') openLb(cur - 1);
        if (e.key === 'ArrowRight') openLb(cur + 1);
      }
    });

    updatePrices();
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
})();
